import Backgroundvideo from "../img/bg1_video.mp4"
function Background() {
    return (
        <video autoPlay loop muted className="video-background">
            <source src={Backgroundvideo} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
    );
};
export default Background